module.exports = __webpack_public_path__ + "media/images/pic/raports-8be3fdecd677f77f00a9ad05277bdd17.svg";